import { convertFromUTCToGivenTimezone, convertUtcStringFormat } from "@common/utils/methods/dateTime";
import { useSelector } from "react-redux";
import { reducerPaths } from "src/app/reducerPaths";

const useGetBuyNowRemainingSeconds = () => {

  const auth = useSelector(store => store[reducerPaths.auth]);

  const getBuyNowAuctionRemainingSeconds = (car) => {
    let buyNowDateTime, buyNowEndDate, buyNowRemainingSeconds;

    buyNowDateTime = convertFromUTCToGivenTimezone({
      dateStr: convertUtcStringFormat(car?.Buy_now_DateTime),
      timezone: auth?.timezone
    });

    buyNowEndDate = new Date(buyNowDateTime);

    buyNowRemainingSeconds = Math.floor((buyNowEndDate.getTime() - new Date().getTime()) > 1000 ?
      (buyNowEndDate.getTime() - new Date().getTime()) / (1000) :
      0);

    return buyNowRemainingSeconds;
  };

  return {
    getBuyNowAuctionRemainingSeconds
  };
}

export {
  useGetBuyNowRemainingSeconds
}